import React, { useEffect, useState, useRef } from 'react';
import cn from 'classnames';

import './coverOne.scss';

function CoverOne(props) {
  const { progress } = props;

  return (
    <>
      <section className={cn('cover cover--1 timeline__cover')}>
        <div className="cover__bg">
          <div className="cover__bg-wrap">
            <div className="cover__bg-col">
              <div className="cover__bg-img cover__bg-img--2">
                <img src="/img/cover_1_2.jpg" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--4">
                <img src="/img/cover_1_4.jpg" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--5">
                <img src="/img/cover_1_5.jpg" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--2-1">
                <img src="/img/cover_1_2.jpg" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--4-1">
                <img src="/img/cover_1_4.jpg" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--5-1">
                <img src="/img/cover_1_5.jpg" alt="img" />
              </div>
            </div>
            <div className="cover__bg-col">
              <div className="cover__bg-img cover__bg-img--1">
                <img src="/img/cover_1_1.jpg" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--1-1">
                <img src="/img/cover_1_1.jpg" alt="img" />
              </div>
            </div>
            <div className="cover__bg-col">
              <div className="cover__bg-img cover__bg-img--3">
                <img src="/img/cover_1_3.png" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--6">
                <img src="/img/cover_1_6.png" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--3-1">
                <img src="/img/cover_1_3.png" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--6-1">
                <img src="/img/cover_1_6.png" alt="img" />
              </div>
            </div>
          </div>
          <div className="cover__bg-wrap cover__bg-wrap--right">
            <div className="cover__bg-col">
              <div className="cover__bg-img cover__bg-img--2">
                <img src="/img/cover_1_2.jpg" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--4">
                <img src="/img/cover_1_4.jpg" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--5">
                <img src="/img/cover_1_5.jpg" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--2-1">
                <img src="/img/cover_1_2.jpg" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--4-1">
                <img src="/img/cover_1_4.jpg" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--5-1">
                <img src="/img/cover_1_5.jpg" alt="img" />
              </div>
            </div>
            <div className="cover__bg-col">
              <div className="cover__bg-img cover__bg-img--1">
                <img src="/img/cover_1_1.jpg" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--1-1">
                <img src="/img/cover_1_1.jpg" alt="img" />
              </div>
            </div>
            <div className="cover__bg-col">
              <div className="cover__bg-img cover__bg-img--3">
                <img src="/img/cover_1_3.png" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--6">
                <img src="/img/cover_1_6.png" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--3-1">
                <img src="/img/cover_1_3.png" alt="img" />
              </div>
              <div className="cover__bg-img cover__bg-img--6-1">
                <img src="/img/cover_1_6.png" alt="img" />
              </div>
            </div>
          </div>
        </div>
        <div className="cover__main">
          <h1 className="cover__title">2007-2011</h1>
          <h2 className="cover__subtitle">Начало истории</h2>
          <p className="cover__text">Через кризис небольшими, но уверенным шагами</p>
        </div>
      </section>
    </>
  );
}

export default CoverOne;
